import classNames from 'classnames';
import React from 'react';

import styles from './styles.module.scss';

export const Trigger = React.forwardRef<HTMLDivElement, { className?: string }>(({ className }, ref) => {
  return <div ref={ref} className={classNames(styles.trigger, className)} />;
});
